import React from "react";
import {
  EmptyStateContainer,
  IconCircle,
  Title,
  Description,
  ActionSlot,
} from "./EmptyState.styles";
import { EmptyStateProps } from "./EmptyState.types";
import { fileIcon, filterIcon } from "assets/icons";

/*
  Типовые тексты. Экран без своих формулировок всё равно объясняет,
  что происходит: раньше на его месте был пустой каркас таблицы,
  по которому нельзя было отличить «данных нет» от «не загрузилось».
*/
const DEFAULTS = {
  empty: {
    title: "Пока пусто",
    description: "Здесь появятся записи, как только они будут добавлены.",
    icon: fileIcon,
  },
  filtered: {
    title: "Ничего не найдено",
    description: "Под выбранные условия не попала ни одна запись.",
    icon: filterIcon,
  },
} as const;

const EmptyState: React.FC<EmptyStateProps> = ({
  kind = "empty",
  title,
  description,
  action,
  icon,
}) => {
  const defaults = DEFAULTS[kind];
  const Icon = icon ?? defaults.icon;

  return (
    <EmptyStateContainer>
      <IconCircle>
        <Icon aria-hidden="true" />
      </IconCircle>
      <Title>{title ?? defaults.title}</Title>
      <Description>{description ?? defaults.description}</Description>
      {action ? <ActionSlot>{action}</ActionSlot> : null}
    </EmptyStateContainer>
  );
};

export default EmptyState;
